"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palazzolo-dello-stella": {
    "2ca0619b": [{
      "hkey": "e2f543a0",
      "slug": "palazzolo-dello-stella",
      "name": "Palazzolo dello Stella",
      "primary": true,
      "skipSearch": false
    }],
    "fraida": [{
      "hkey": "e2f543a0",
      "slug": "palazzolo-dello-stella",
      "name": "Palazzolo dello Stella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;